// extracted by mini-css-extract-plugin
module.exports = {"input":"NumberInput_input__DiA3u","error":"NumberInput_error__3sjHw"};